import { StatusMessage } from '@aimsos/ui';

import { Inbox } from 'lucide-react';

/**
 * Nothing to show, and that is a legitimate outcome rather than a failure.
 *
 * Caller-supplied copy: an empty hub and an empty entity list want to say
 * different things, and only the caller knows which. `action` is optional —
 * most empty states here have nothing useful to offer, and a button that only
 * exists to fill the space is worse than none.
 *
 * `testId` because "nothing matched your search" and "this type has no records"
 * are different states rendered by the same component, and a test that cannot
 * tell them apart cannot pin the difference.
 */
function EmptyState({ title, subtitle, icon = Inbox, action = null, testId = 'empty-state' }) {
  return (
    <div data-testid={testId} className="flex flex-1 flex-col items-center justify-center gap-6">
      <StatusMessage icon={icon} title={title} subtitle={subtitle} />
      {action}
    </div>
  );
}

export default EmptyState;
